/**
 * ClubEzy Auth Client — Development Environment
 * Firebase project: clubezy-app-dev
 */
export const environment = {
  production: false,
  envName: 'dev' as const,
  useEmulators: false,
  // ── Sentry error tracking ───────────────────────────────────────────────
  // One Sentry project per app (auth client / admin / members / functions).
  // dev, staging and production all report into the auth-client project and
  // are told apart by the `environment` tag, which is `envName` above.
  //
  // Dev reports too — a dev-only crash that never reaches Sentry is a crash
  // nobody sees until it ships.
  //
  // Sentry project `clubezy-auth` in the `namadgi` org.
  sentry: {
    dsn: 'https://f6e68e61989270ab040acb408709b810@o26287.ingest.us.sentry.io/4511960317034496',
    enabled: true,
  },
  firebase: {
    apiKey: 'AIzaSyAX8kGGWvQe0tFlNDWb33Y3vg9s3pvQPyU',
    authDomain: 'clubezy-app-dev.firebaseapp.com',
    projectId: 'clubezy-app-dev',
    storageBucket: 'clubezy-app-dev.firebasestorage.app',
    messagingSenderId: '927279646213',
    appId: '1:927279646213:web:206ba8b33c56364e8ebe6c',
  },
  functionsUrl:
    'https://australia-southeast1-clubezy-app-dev.cloudfunctions.net',
  googleMapsApiKey: 'AIzaSyAobGR_V_8niUTz6SYBG9Rc1JwEX_r0Vo0',
  links: {
    // authAction: 'https://auth-test.clubezy.com/auth/action',
    authAction: 'https://clubezy-auth-dev.web.app/auth/action',
    admin: 'https://admin-test.clubezy.com',
    member: 'https://member-test.clubezy.com',
    dashboard: 'https://dashboard-test.clubezy.com',
    privacy:
      'https://docs.google.com/document/u/1/d/e/2PACX-1vSj5wt1qMzfGgpe6hj8YifSGmMl_z7gVt62hRY8i0qlSn3wTAzrllAQsjYfOcyeiarb4dw83t3I39oK/pub',
    // Legal + marketing surfaces on the public site. Not env-specific — there
    // is one clubezy.com — but kept here with the other links so every
    // outbound URL the app renders is declared in one place.
    terms: 'https://www.clubezy.com/terms/',
    website: 'https://www.clubezy.com/',
  },
};
